import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function KeyIcon({ color: colorProp }: IconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3012_2566)">
        <path
          d="M6 5.5C6 3.01562 8.01562 1 10.5 1C12.9844 1 15 3.01562 15 5.5C15 7.98438 12.9844 10 10.5 10C10.1531 10 9.8125 9.95937 9.4875 9.8875C9.31875 9.85 9.14375 9.9 9.02188 10.0219L8.04375 11H6.5C6.225 11 6 11.225 6 11.5V13H4.5C4.225 13 4 13.225 4 13.5V15H1V12.4563L6.0875 7.36875C6.21875 7.2375 6.26562 7.04063 6.20937 6.8625C6.07188 6.43125 6 5.975 6 5.49687V5.5ZM10.5 0C7.4625 0 5 2.4625 5 5.5C5 5.97188 5.05937 6.43125 5.17188 6.87187L0.146875 11.8969C0.053125 11.9906 0 12.1187 0 12.25V15.5C0 15.775 0.225 16 0.5 16H4.5C4.775 16 5 15.775 5 15.5V14H6.5C6.775 14 7 13.775 7 13.5V12H8.25C8.38125 12 8.50937 11.9469 8.60312 11.8531L9.54062 10.9156C9.85312 10.9719 10.1719 11 10.5 11C13.5375 11 16 8.5375 16 5.5C16 2.4625 13.5375 0 10.5 0ZM11.5 5.25C11.6989 5.25 11.8897 5.17098 12.0303 5.03033C12.171 4.88968 12.25 4.69891 12.25 4.5C12.25 4.30109 12.171 4.11032 12.0303 3.96967C11.8897 3.82902 11.6989 3.75 11.5 3.75C11.3011 3.75 11.1103 3.82902 10.9697 3.96967C10.829 4.11032 10.75 4.30109 10.75 4.5C10.75 4.69891 10.829 4.88968 10.9697 5.03033C11.1103 5.17098 11.3011 5.25 11.5 5.25Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3012_2566">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default KeyIcon;
